// extracted by mini-css-extract-plugin
export default {"gallery":"FacilityImages_gallery__Mnu8a","card":"FacilityImages_card__FV1+d","image":"FacilityImages_image__7O-Kh","title":"FacilityImages_title__UGBbI"};